'use strict';
define('translations',['jquery', 'errorHandler', 'qlib', 'i18next'], function ($, errorHandler, qlib, i18next) {
	var translations = {
		translate: translate,
		initLanguage: initLanguage,
		dict: {},
		langList: {}
	};

	function i18nextSetup(currentLng, translationsMap) {
		// add additional key to the translation structure for i18next library
		Object.keys(translationsMap).forEach((item) => {
			translationsMap[item].translation = translationsMap[item];
		});

		i18next
			.init({
				debug: false,
				keySeparator: false,
				nsSeparator: false,
				contextSeparator: '|',
				fallbackLng: 'en',
				lng: currentLng,
				useLocalStorage: true,
				useDataAttrOptions: true,
				resources: translationsMap
			}, function (err) {
				if (err) {
					errorHandler.logError('ERROR', 'failed to load i18n library', null, {
						fullErr: err,
						errorMessage: err
					});
				}
			});
	}

	function findWithAnyTag(language, list) {
		var keys = Object.keys(list),
			modifiedString = '^' + language.replace('*', '.*') + '$',
			regexp = new RegExp(modifiedString),
			matchedKeys = [];

		keys.forEach(function (key) {
			if (key.match(regexp)) {
				matchedKeys.push(key);
			}
		});
		return matchedKeys.sort(function (a, b) {
			return a.toLowerCase() - b.toLowerCase();
		})[0];
	}

	function fallbackLanguage(language) {
		var index = language.lastIndexOf('-');

		if (index === -1) {
			return undefined;
		}
		return language.slice(0, index);
	}

	function findLanguage(language, list) {
		var withAnyTag;

		if (list.hasOwnProperty(language) || !language) {
			return language;
		}
		if (language.indexOf('*') !== -1 && language.indexOf('-') !== -1) {
			withAnyTag = findWithAnyTag(language, list);
			if (withAnyTag) {
				return withAnyTag;
			}
		}
		return findLanguage(fallbackLanguage(language), list);
	}

	function fromNavigator(list) {
		var i,
			lang;

		if (window.navigator.languages) {
			for (i = 0; i < window.navigator.languages.length; i++) {
				lang = findLanguage(window.navigator.languages[i], list);
				if (lang) {
					return lang;
				}
			}
		}
		return findLanguage(window.navigator.language, list);
	}

	function getLanguage(language, list) {
		const lang = findLanguage(language, list) || fromNavigator(list) || 'en';
		const promises = [];

		translations.locale = lang;

		function request(listItem, def) {
			const deferred = def || qlib.defer();

			 $.get(list[listItem].path)
				.then(function (data) {
					translations.dict[listItem] = data;

					return deferred.resolve();
				}, function () {
					setTimeout(() => {
							errorHandler.showError('Failed to load translations', 5000);
						request(listItem, deferred);
					}, 2000);
				});
			 return deferred.promise;
		}

		promises.push(request('en'));
		if (lang !== 'en') {
			promises.push(request(lang));
		}

		return qlib.all(promises);
	}

	function initLanguage(lang) {
		var deferred = qlib.defer();

		request();
		function request() {
			$.get('languages/langs.json')
				.then(function (data) {
					translations.langList = data;
					getLanguage(lang, data)
						.then(() => {
							i18nextSetup(lang, translations.dict);
							deferred.resolve();
						});
				}, function () {
					setTimeout(() => {
						errorHandler.showError('Failed to load translations', 5000);
						request();
					}, 1000);
				});
		}
		return deferred.promise;
	}

	function translate(str) {
		return i18next.t(str);
	}

	return translations;
});

